import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IUnit } from "../services/unitService";
import { Preferences } from "@capacitor/preferences";

const STORAGE_NAME = "unit-detail-storage";

interface UnitDetailState {
  unit: IUnit | null;
  isLoading: boolean;
  isInitialLoaded: boolean;
  setUnit: (unit: IUnit) => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsInitalLoaded: (isInitialLoaded: boolean) => void;
  reset: () => void;
}

const capacitorPreferencesStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: (key: string, value: string) => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string) => {
    return Preferences.remove({ key });
  },
};

const useUnitDetailStore = create<UnitDetailState>()(
  devtools(
    persist(
      (set) => ({
        unit: null,
        isLoading: true,
        isInitialLoaded: false,
        setUnit: (unit: IUnit) => set({ unit }),
        setIsLoading: (isLoading: boolean) => set({ isLoading }),
        setIsInitalLoaded: (isInitialLoaded: boolean) =>
          set({ isInitialLoaded }),
        reset: () => {
          set({
            unit: null,
            isLoading: true,
            isInitialLoaded: false,
          });
        },
      }),
      {
        name: STORAGE_NAME,
        storage: createJSONStorage(() => capacitorPreferencesStorage),
      }
    )
  )
);

export default useUnitDetailStore;
